import ApexCharts from 'apexcharts'

const recapDonutCharts = (gsap, $container) => {
	
	const $donut1 = $container.find('#donut1');
	const $donut2 = $container.find('#donut2');
	const $donut3 = $container.find('#donut3');
	const $donut4 = $container.find('#donut4');
	
	function createDonut(item, series1, series2, label) {
		if (!item || !item.isConnected) return null;
		
		try {
			var options = {
				series: [series1, series2],
				colors: ['#E2185B', '#1E7CAE'],
				chart: {
					type: 'donut',
					fontFamily: 'Aeonik',
					height: '100%',
					width: '100%',
				},
				dataLabels: {
					enabled: false,
				},
				legend: {
					show: false,
				},
				labels: ['Live + SD AA (000)', 'Out of Home Live + SD AA (000)'],
				stroke: {
					show: false,
				},
				states: {
					hover: {
						filter: {
							type: 'none',
						}
					},
					active: {
						filter: {
							type: 'none',
						}
					}
				},
				tooltip: {
					enabled: true,
					shared: false,
					followCursor: false,
					custom: function({w, series, seriesIndex}) {
						const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
						const percentage = Math.round((series[seriesIndex] / total * 100));
						
						return `
							<div class="recap-donut-tooltip">
								<span>${w.globals.labels[seriesIndex]}:</span>
								<strong>${percentage}%</strong>
								<strong>${series[seriesIndex].toLocaleString()}</strong>
							</div>
						`.trim();
					}
				},
				plotOptions: {
					pie: {
						expandOnClick: false,
						donut: {
							labels: {
								show: true,
								total: {
									show: true,
									showAlways: true,
									color: '#fff',
									fontSize: '16px',
									fontWeight: 700,
									label: label,
									formatter: function(w) {
										return 'Total: ' + w.globals.seriesTotals.reduce((a, b) => a + b, 0).toLocaleString();
									}
								},
								value: {
									show: true,
									color: '#fff',
									offsetY: -5,
									fontSize: '13px',
									formatter: function(w) {
										return w.toLocaleString();
									}
								}
							}
						}
					}
				}
			};
			
			return new ApexCharts(item, options);
		} catch (error) {
			console.warn('Failed to create donut chart:', error);
			return null;
		}
	}
	
	function createIntersectionObserver(element, series1, series2, label) {
		if (!element || !element.isConnected) return null;
		
		// Create the chart immediately but don't render it yet
		const chart = createDonut(element, series1, series2, label);
		if (!chart) return;
		
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// Only render the chart when it comes into view
					chart.render();
					observer.disconnect();
				}
			});
		}, {
			threshold: 1.0
		});
		
		observer.observe(element);
	}
	
	// Create Intersection Observer for each donut chart
	if ($donut1.length) {
		createIntersectionObserver($donut1[0], 186356, 30778, 'CBS');
	}

	if ($donut2.length) {
		createIntersectionObserver($donut2[0], 43289, 20306, 'TBS');
	}

	if ($donut3.length) {
		createIntersectionObserver($donut3[0], 20622, 18063, 'TNT');
	}

	if ($donut4.length) {
		createIntersectionObserver($donut4[0], 24430, 15705, 'TRUTV');
	}
}

export { recapDonutCharts };